import React, { useState } from 'react';
import { PlayCircleIcon } from 'lucide-react';
import { BookCallButton } from './BookCallButton';
import { VideoModal } from './VideoModal';
const PLAYBOOK_VIDEO_URL = 'https://www.youtube.com/embed/d0PXfzexj4M?si=WxnTloThEfqlgXhZ';
export function Hero() {
  const [videoOpen, setVideoOpen] = useState(false);
  return <section className="w-full px-6 md:px-12 pt-2 md:pt-4 pb-12 md:pb-16 max-w-7xl mx-auto grid md:grid-cols-12 gap-4 lg:gap-6 items-center" data-id="element-86">
      <div className="md:col-span-6" data-id="element-87">
        <p className="text-xs uppercase tracking-widest text-accent mb-5 font-medium" data-id="element-88">
          Your Year One Mentor
        </p>
        <h1 className="text-6xl md:text-6xl lg:text-7xl font-serif leading-[1.05] mb-6" data-id="element-89">
          From school to career<span className="text-accent" data-id="element-90">.</span>
        </h1>
        <p className="text-lg md:text-xl text-ink/80 mb-8 leading-relaxed max-w-xl font-light" data-id="element-91">
          I give new grads the real-world guidance they didn't get in school,
          helping them build clarity, confidence, and a path toward their first
          career move.
        </p>
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-92">
          <BookCallButton data-id="element-93" />
          <button type="button" onClick={() => setVideoOpen(true)} className="btn-outline whitespace-nowrap inline-flex items-center gap-2" data-id="element-94">
            <PlayCircleIcon className="w-5 h-5" data-id="element-95" />
            New Career Playbook
          </button>
        </div>
      </div>

      <div className="md:col-span-6 relative w-full flex justify-center md:justify-start" data-id="element-96">
        <img src="https://cdn.magicpatterns.com/uploads/5XSLWnr32KfcvXxwtYAyhP/ChatGPT_Image_May_13,_2026,_09_33_32_PM.png" alt="Illustration of a graduate crossing a bridge toward a working professional, symbolizing the journey from school to career." className="w-full max-w-[640px] h-auto" data-id="element-97" />
      </div>

      <VideoModal open={videoOpen} onClose={() => setVideoOpen(false)} videoUrl={PLAYBOOK_VIDEO_URL} data-id="element-98" />
    </section>;
}